import styled, { css } from 'styled-components';
import { Typography } from '../ui/Typography';

export const modalStyles = css`
  height: max-content;
  width: calc(100% - 30px);
  border-radius: 14px;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    width: 475px;
    height: max-content;
  }
`;

export const ErrorModalContent = styled.div`
  padding: 25px 20px 20px;
  height: 100%;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    padding: 40px 50px;
  }
`;

export const ModalTitle = styled(Typography)`
  display: block;
  text-align: center;
  margin-bottom: 10px;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    margin-bottom: 25px;
  }
`;

export const ModalMessage = styled(Typography)`
  display: block;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: 20px;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    margin-bottom: 30px;
  }
`;
